// src/CloseIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CloseIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M18 6 6 18" }),
      /* @__PURE__ */ jsx("path", { d: "m6 6 12 12" })
    ]
  }
);
var CloseIcon_default = CloseIcon;

export {
  CloseIcon_default
};
